import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import ReportError from "../ReportError";
import FormReportError from "../ReportError/components/FormReportError";
import { LIST_PROBLEM_BOOK } from "../ReadingBooks/components/const";
import { postSaveReportError } from "../../services/reportError";
import PopUpReportSuccess from "../DoingExercise/ReportError/PopUpReportSuccess";

export default function FormRev002(props) {
	const [showFormReportErrorModal, setShowFormReportErrorModal] =
		      useState(false);
	const [showPopUpReportSuccessModal, setShowPopUpReportSuccessModal] =
		      useState(false);
	const onReport = () => {
		console.log(props);
		setShowFormReportErrorModal(true);
	};
	const saveReportError = (data) => {
		const postData = {
			book_id: props.dataBook.bookId,
			page_id: props.dataBook.pageId,
			object_id: props.dataBook.objectId,
			object_layer: "main",
			data: data,
			activity_id: props.dataBook.activity_id,
		};

		if (
			data.answer ||
			data.image ||
			data.question ||
			data.other_problems ||
			data.input_other_problems !== ""
		) {
			postSaveReportError(postData).catch((errors) => {
				console.log(errors);
			});
			setShowFormReportErrorModal(false);
			setShowPopUpReportSuccessModal(true);
		}
	};
	const handleClose = () => {
		setShowFormReportErrorModal(false);
		setShowPopUpReportSuccessModal(false);
	};
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton className="header-bg-reference">
          <Modal.Title
            className="monkey-color-violet modal-title quicksand-bold w-100 text-center pl-3"
            style={{
              fontSize: `${
                props?.data?.font_size ? props?.data?.font_size : 20
              }px`,
            }}
          >
            <span>Hướng dẫn và Gợi ý một phương án tổ chức dạy học</span>
          </Modal.Title>
        </Modal.Header>
	      <Modal.Body
		      className="pl-0 pr-0 pt-1 pb-1"
		      style={{
			      maxHeight: '80vh', // hoặc 400px, tùy bạn muốn giới hạn bao nhiêu
			      overflowY: 'auto',
		      }}
	      >
		      {props?.data?.data?.map((item, index) => (
			      <div key={index} className="form-group form-check border-2 pt-3 pb-3 pr-3 d-flex align-items-center"
			           style={{
						   textAlign: 'justify',
				           fontSize: `${
					           item?.font_size ? item.font_size : 28
				           }px`,
			           }}
			      >
				      <div dangerouslySetInnerHTML={{ __html: item?.content }} />
			      </div>
		      ))}
	      </Modal.Body>
	     
	      {showFormReportErrorModal && (
		      <FormReportError
			      saveReportError={saveReportError}
			      show={showFormReportErrorModal}
			      onHide={handleClose}
			      listProblems={LIST_PROBLEM_BOOK}
		      />
	      )}
	      {showPopUpReportSuccessModal && (
		      <PopUpReportSuccess
			      show={showPopUpReportSuccessModal}
			      onHide={handleClose}
		      />
	      )}
	      <ReportError onReport={onReport} />
      </Modal>
	   
    </>
  );
}
